/** Default hover delay before the tooltip opens (ms). Matches org/admin wrappers. */
export const tooltipDefaultOpenDelayMs = 200;

/** Shorter open delay when `interactive` — easier to reach clickable content inside the tooltip. */
export const tooltipInteractiveOpenDelayMs = 100;

/** Close delay when `interactive` — keeps the tooltip open while moving the cursor to its content. */
export const tooltipInteractiveCloseDelayMs = 1000;
